import {Box, Container, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

export default function NoScoringSystems() {
  const {t} = useTranslation(['practitioner/common']);

  return (
    <Container maxWidth="md" disableGutters>
      <Box
        component="fieldset"
        sx={{
          textAlign: 'center',
          my: 4,
          borderColor: 'transparent'
        }}
      >
        <Typography align="center" component="legend" gutterBottom>
          {t('practitioner/common:diagnosticReport.form.noScoringSystems.title')}
        </Typography>
        <Typography
          variant="h2"
          align="center"
          component="legend"
          sx={{
            mb: '16px'
          }}
        >
          {t('practitioner/common:diagnosticReport.form.noScoringSystems.text')}
        </Typography>
      </Box>
    </Container>
  );
}
